import React from 'react';
import classNames from 'classnames';

import { AccordionContext } from '@buyside/components/presentation/Accordion/accordionContext';

import styles from '@buyside/components/presentation/Accordion/AccordionParts/accordionStyles.scss';

const Accordion: React.FunctionComponent<{
  basic?: boolean;
  initialOpen?: boolean;
  children?: React.ReactNode;
  shadowless?: boolean;
  className?: string;
}> = ({
  basic,
  children,
  initialOpen = true,
  shadowless = false,
  className
}): React.ReactElement => {
  const [isExpanded, toggle] = React.useState(initialOpen);

  return (
    <AccordionContext.Provider
      value={{ isExpanded, toggleExpand: (): void => toggle(!isExpanded) }}
    >
      <div
        className={classNames(className, styles.accordion, {
          [styles.shadowless]: shadowless,
          [styles.basic]: basic
        })}
      >
        {children}
      </div>
    </AccordionContext.Provider>
  );
};

export default Accordion;
